module.exports = __webpack_public_path__ + "static/media/zippe-logo.a6e30ef0.png";